import React, { useState, useEffect, useRef, useMemo } from 'react';
import MaterialTable from 'material-table';
import { useSelector, useDispatch } from "react-redux";
import CircularLoading from "../components/CircularLoading";
import { api } from 'common';
import { useTranslation } from "react-i18next";
import {colors} from '../components/Theme/WebTheme';
import { downloadCsv } from '../common/sharedFunctions';
import { Select, MenuItem, Modal, Grid, Typography, Tooltip, CircularProgress, Checkbox, ListItemText } from '@mui/material';
import AlertDialog from "../components/AlertDialog";
import CancelIcon from '@mui/icons-material/Cancel';
import { makeStyles } from '@mui/styles';
import Button from "components/CustomButtons/Button.js";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  submit3:{
    width:'100%',
    borderRadius:3,
    marginTop:2,
    padding:4
  },
  paper: {
    width: '90%',
    maxWidth: 500,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    borderRadius:15,
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

export default function SubAdmins() {
  const { t,i18n } = useTranslation();
  const isRTL = i18n.dir();
  const settings = useSelector(state => state.settingsdata.settings);
  const {
    addUser,
    editUser, 
    revokeUserTokens,
    checkUserExists,
    fetchUsersOnce
  } = api;
  const [data, setData] = useState([]);
  const staticusers = useSelector(state => state.usersdata.staticusers);
  const dispatch = useDispatch();
  const loaded = useRef(false);
  const countries = useSelector(state => state.countrylistdata.countries);
  const [countryList, setCountryList] = useState();
  const [commonAlert, setCommonAlert] = useState({ open: false, msg: "" });
  const [selectedImage, setSelectedImage] = useState(null); 
  const [userData, setUserData] = useState();
  const [profileModal, setProfileModal] =  useState(false);
  const [imageData, setImageData] =  useState(false);
  const [loading, setLoading] = useState(false);
  const classes = useStyles();
  const handleProfileModal = (e) => {
    setProfileModal(false);
    setSelectedImage(null);
  }

  const handleSetProfileModal = (e) =>{
    e.preventDefault();
    if(selectedImage){
      setLoading(true);
      let finalData = userData;
      finalData.profile_image = selectedImage;
      dispatch(editUser(finalData.id,finalData, "UpdateImage"));
      setProfileModal(false); 
      setTimeout(()=>{
        dispatch(fetchUsersOnce());
        setSelectedImage(null);
        setLoading(false); 
      },10000);
    }
    else{
      setCommonAlert({ open: true, msg: t('choose_image_first') })
    }
  }

  const onClick = (rowData) => {
    setImageData(rowData.profile_image);
    setProfileModal(true);
    setUserData(rowData);
  };

  useEffect(()=>{
    if(countries){
      let list = {};
      for(let i=0; i<countries.length; i++){
        let obj = countries[i];
        list[obj.country] = obj.country
      }
      setCountryList(list);
    }
  },[countries])

  useEffect(()=>{
    dispatch(fetchUsersOnce());
  },[dispatch,fetchUsersOnce]);

  useEffect(()=>{
    if(staticusers){
      setData(staticusers.filter(user => user.usertype ==='subadmin').map(user => ({...user})));
    }else{
      setData([]);
    }
    loaded.current = true;
  },[staticusers]);


  const menuOptions = useMemo(() => [
        {name : t('home'), pos: 0},
        {name : t('dashboard_text'), pos:1},
        {name : t('booking_history'), pos:2},
        {name : t('addbookinglable'), pos:3},
        {name : t('user'), url:'/users', pos:4},
        {name : t('pricing'), url:'/pricing', pos:5},
        {name : t('cars'), url:'/cars',pos:6},
        {name : t('add_to_wallet'), pos:7},
        {name : t('deduct_from_wallet'), pos:8},
        {name : t('withdraws'), pos:9},
        {name : t('chatAdm'), pos:10},
        {name : t('promo'), pos:11},
        {name : t('push_notification_title'), pos:12},
        {name : t('cancellation_reasons'), pos:13},
        {name : t('report'), url:'/allreports', pos:14},
        {name : t('sos'), url:'/sos', pos:15},
        {name : t('complain'), url:'/complain', pos:16},
        {name : t('settings_title'), url:'/settings', pos:17}
  ], [t]);

  const expandOpts = React.useCallback((mOpts) => {
    let str = "";
    if (mOpts && mOpts.length > 0) {
      for (let i = 0; i < mOpts.length; i++) {
        if (menuOptions[mOpts[i]]) {
          str = str + menuOptions[mOpts[i]].name + ", "
        }
      }
      return str.substring(0, str.length - 2);
    }
    return "";
  }, [menuOptions]);

  const columns = useMemo(() => [
    { title: t('first_name'), field: 'firstName', initialEditValue: ''},
    { title: t('last_name'), field: 'lastName', initialEditValue: '', },
    { title: t('mobile'), field: 'mobile', editable:'onAdd',render: rowData => settings.AllowCriticalEditsAdmin ?rowData.mobile : "Hidden for Demo"},
    { title: t('email'), field: 'email', editable:'onAdd',render: rowData => settings.AllowCriticalEditsAdmin ?rowData.email : "Hidden for Demo",headerStyle:{textAlign:'center'}},
    { title: t('profile_image'), field: 'profile_image',initialEditValue: 'https://cdn.pixabay.com/photo/2021/07/25/08/03/account-6491185_1280.png', render: rowData => rowData.profile_image?<button onClick={()=>{onClick(rowData)}}><img alt='profile_image' src={rowData.profile_image} style={{width: 50}}/></button>:null, editable:'never',},
    { title: t('country'), field: 'country', lookup: countryList, editable:'onAdd' },
    {
        title: "Select ",
        field: 'menuOptions',
        render: rowData => expandOpts(rowData.menuOptions),
        editComponent: (props) => {
          const { value, onChange } = props;
          const selectedValues = value ? value : [];
          return (
           <Select
            labelId="labelId"
            id="selectId"
            multiple={true}
            value={selectedValues}
            onChange={(event) => {
              const {
                target: { value }
              } = event;
              onChange(typeof value === "string" ? value.split(",") : value);
            }}
            style={{ width: '100%', maxWidth: 250 }}
            MenuProps={{
              PaperProps: {
                style: {
                  maxHeight: 400,
                  maxWidth: 250,
                },
              },
            }}
            renderValue={(selected) => {
              if (selected.length > 2) {
                return `${selected.length} items selected`;
              }
              return expandOpts(selected);
            }}
          >
            { menuOptions.map((option) => (
              <MenuItem key={"key" + option.pos} value={option.pos} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                <Checkbox checked={selectedValues.indexOf(option.pos) > -1} />
                <ListItemText primary={option.name} />
              </MenuItem>
            ))}
          </Select>
        );      
        }
    }
  ], [t, settings.AllowCriticalEditsAdmin, countryList, menuOptions, expandOpts]);

  const [selectedRow, setSelectedRow] = useState(null);

  const handleCommonAlertClose = (e) => {
    e.preventDefault();
    setCommonAlert({ open: false, msg: "" });
  };

  return (
    !loaded.current? <CircularLoading/>:
    <>
    <div style={{ width: '100%', overflowX: 'auto' }}>
      <MaterialTable
        title={t('subadmins')}
        columns={columns}
        style={{direction:isRTL ==='rtl'?'rtl':'ltr',  borderRadius: "8px", boxShadow: "4px 4px 6px #9E9E9E"}}
        data={data}
      onRowClick={((evt, selectedRow) => setSelectedRow(selectedRow.tableData.id))}
      options={{
        pageSize: 10,
        pageSizeOptions: [10, 15, 20],
        exportCsv: (columns, data) => {
          let hArray = [];
          const headerRow = columns.map(col => {
            if (typeof col.title === 'object') {
              return col.title.props.text;
            }
            hArray.push(col.field);
            return col.title;
          });
          const dataRows = data.map(({ tableData, ...row }) => {
            row.createdAt = new Date(row.createdAt).toLocaleDateString() + ' '+ new Date(row.createdAt).toLocaleTimeString()
            let dArr = [];
            for(let i=0;i< hArray.length; i++) {
              dArr.push(row[hArray[i]]);
            }
            return Object.values(dArr);
          })
          const { exportDelimiter } = ",";
          const delimiter = exportDelimiter ? exportDelimiter : ",";
          const csvContent = [headerRow, ...dataRows].map(e => e.join(delimiter)).join("\n");
          const csvFileName = 'download.csv';
          downloadCsv(csvContent, csvFileName);
        },
        exportButton: {
          csv: settings.AllowCriticalEditsAdmin,
          pdf: false,
        },
        maxColumnSort: "all_columns",
        rowStyle: rowData => ({
          backgroundColor: (selectedRow === rowData.tableData.id) ?  colors.THIRDCOLOR: colors.WHITE
        }),
        editable:{
          backgroundColor: colors.WHITE,
          fontSize: "0.8em",
          fontWeight: 'bold ',
          fontFamily: 'Lucida Console", "Courier New", monospace'
        },
        headerStyle: {
          position: "sticky",
          top: "0px",
          backgroundColor: colors.SECONDARY ,
          color:colors.WHITE,
          fontSize: "0.8em",
          fontWeight: 'bold ',
          fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
          border: `1px solid rgba(224, 224, 224, 1)`,
          textAlign: "center",
        },
        cellStyle: {
          border: `1px solid rgba(224, 224, 224, 1)`,
          textAlign: "center",
        },
        actionsColumnIndex: -1,
      }}
      localization={{body:{
        addTooltip: (t('add')),
        deleteTooltip: (t('delete')),
        editTooltip: (t('edit')),
        emptyDataSourceMessage: (
          (t('blank_message'))
      ),
      editRow: { 
        deleteText: (t('delete_message')),
        cancelTooltip: (t('cancel')),
        saveTooltip: (t('save')) 
          },
        },
        toolbar: {
          searchPlaceholder: (t('search')),
          exportTitle: (t('export')),
        },
        header: {
          actions: (t('actions')) 
      },
      pagination: {
        labelDisplayedRows: ('{from}-{to} '+ (t('of'))+ ' {count}'),
        firstTooltip: (t('first_page_tooltip')),
        previousTooltip: (t('previous_page_tooltip')),
        nextTooltip: (t('next_page_tooltip')),
        lastTooltip: (t('last_page_tooltip'))
      },
      }}
      editable={{
        onRowAdd: newData =>
        new Promise((resolve,reject) => {
          setTimeout(() => {
            checkUserExists(newData).then((res) => {
              if (res.users && res.users.length > 0) {
                alert(t('user_exists'));
                reject();
              }
              else if(!(newData && newData.firstName)){
                alert(t('proper_input_name'));
                reject();
              }
              else if(res.error){
                alert(t('email_or_mobile_issue'));
                reject();
              }
              else if(!(newData.country)) {
                alert(t('country_blank_error'));
                reject();
              } else if(!(newData.menuOptions)){
                alert(t('page_access'));
                reject();
              }else {
                newData['usertype'] = 'subadmin';
                newData['createdAt'] = new Date().getTime();
                dispatch(addUser(newData)).then(() => {
                  dispatch(fetchUsersOnce());
                })
                .catch((error) => {
                  let errorMessage;
                  try {
                    const errorObj = JSON.parse(error.message);
          
                    if (errorObj.errorType === 'invalid_mobile_length') {
                      errorMessage = t("mobile_err_txt1") + " " + errorObj.expectedMobileLength + " " + t("mobile_err_txt2") + errorObj.actualMobileLength + t("mobile_err_txt3");
                    } else {
                      errorMessage = t(errorObj.errorType || "email_or_mobile_issue");
                    }
                  } catch (e) {
                    errorMessage = t("email_or_mobile_issue");
                  }
          
                  alert(errorMessage);
                })
                resolve();
              }
            });
          }, 600);
        }),
        onRowUpdate: (newData, oldData) =>
        settings.AllowCriticalEditsAdmin? new Promise((resolve,reject)=> {
            setTimeout(() => {
              if(!(newData && newData.firstName)){
                alert(t('proper_input_name'));
                reject();
              }else if(!newData.menuOptions || newData.menuOptions.length === 0){
                alert(t('page_access'));
                reject();
              }else {
                resolve();
                if(newData !== oldData){
                  delete newData.tableData;
                  dispatch(editUser(oldData.id,newData));
                  dispatch(fetchUsersOnce());
                }
              }
            }, 600);
          }):new Promise(resolve => {
            setTimeout(() => {
              resolve();
              setCommonAlert({ open: true, msg: t('demo_mode') });
            }, 600);
          }),
            onRowDelete: async (oldData) => {
              try{
                if (settings.AllowCriticalEditsAdmin) {
                  await revokeUserTokens(oldData.id);
                  return new Promise((resolve) => {
                    setTimeout(() => {
                      dispatch(fetchUsersOnce());
                      resolve();
                    }, 600);
                  });
                } else {
                  return new Promise((resolve) => {
                    setTimeout(() => {
                      setCommonAlert({ open: true, msg: t('demo_mode') });
                      resolve();
                    }, 600);
                  });
                }
              }catch(error){
                console.log("error in deletion", error);
              }
            },  
      }}
      
    />
     <Modal
        disablePortal
        disableEnforceFocus
        disableAutoFocus
        open={profileModal}
        onClose={handleProfileModal}
        className={classes.modal}
      >
      <Grid container spacing={1} className={classes.paper} style={{direction:isRTL==='rtl'?'rtl':'ltr'}}>
        <Grid item xs={12} sm={12} md={12} lg={12}>
            <Typography component="h1" variant="h6">
                {t('profile_image')}
              <input
                  type="file"
                  style={{marginLeft:10}}
                  name= {t('image')}
                  onChange={(event) => {
                      setSelectedImage(event.target.files[0]);
                  }}
              />
            </Typography>
         </Grid>
         <Grid item xs={12} sm={12} md={12} lg={12}>
                  {selectedImage  && !loading ? 
                    <Tooltip title={t('cancel')}>
                      <CancelIcon onClick={()=>setSelectedImage(null)} style={{ fontSize: 30,backgroundColor:colors.RED,borderRadius:50,color:colors.WHITE}}  />
                    </Tooltip>
                  : null }
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  {selectedImage ? 
                   <img alt="not fount" src={URL.createObjectURL(selectedImage)} style={{width:'200px', height:'200px', marginTop:15,marginBottom:20, objectFit: 'cover', borderRadius: '19px'}}/>
                   :
                    <img alt="not fount" src={imageData} style={{width:'200px', height:'200px', marginTop:10, objectFit: 'cover', borderRadius: '19px'}}/>
                  }
                <br />
                </Grid>

          <Grid item xs={12} sm={12} md={12} lg={12} style={{textAlign:isRTL==='rtl'?'right':'left'}}>
          {loading ? 
            <Grid
              container
              spacing={0}
              alignItems="center"
              justify="center"
              style={{ minHeight: '5vh' }} >
              <CircularProgress/>
            </Grid>
            :
            <Grid item xs={12} sm={12} md={12} lg={12} style={{textAlign:isRTL==='rtl'?'right':'left'}}>
            <Button onClick={handleProfileModal} variant="contained" color="danger">
              {t('cancel')}
            </Button>
            <Button onClick={handleSetProfileModal} variant="contained" color="success" style={{marginLeft:10}}>
              {t('save')}
            </Button>
            </Grid>
          }
          </Grid>
        </Grid>
      </Modal>
     <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>
        {commonAlert.msg}
      </AlertDialog>
    </div>
    </>
  );
}
